/**
 * The reading pages' contents bar (the headings on the left), collapsible on
 * wide screens and remembered across books and sessions.
 */

export const TOC_WIDTH = 280;
const KEY = "reader-toc";

/** Whether the contents bar was open last time; open by default. */
export const readTocOpen = () => { try { return localStorage.getItem(KEY) !== "closed"; } catch { return true; } };
export const saveTocOpen = (open) => { try { localStorage.setItem(KEY, open ? "open" : "closed"); } catch { /* not remembered */ } };
